import * as React from 'react';
import s from '../ChangePlanModal.scss';
import { useTranslation } from 'react-i18next';
import { CustomModalLayout } from '@wix/design-system';
import { ChangePlanModalComparePlans } from './ChangePlanModalCompare';
import { ChangePlanModalMessage } from './ChangePlanModalMessage';
import { ChangePlanModalSummary } from './ChangePlanModalSummary';

interface ChangePlanModalBodyProps {
  confirmTextKey: string;
  handleChangePlan(): void;
  onCloseChangePlanModal(): void;
}

export const ChangePlanModalBody: React.FC<ChangePlanModalBodyProps> = ({
  confirmTextKey,
  handleChangePlan,
  onCloseChangePlanModal,
}) => {
  const { t } = useTranslation();
  return (
    <CustomModalLayout
      width='840px'
      title={t('change_plan.change_plan_modal.title')}
      onCloseButtonClick={onCloseChangePlanModal}
      primaryButtonText={t(confirmTextKey)}
      primaryButtonOnClick={handleChangePlan}
      secondaryButtonText={t('change_plan.change_plan_modal.cancel')}
      secondaryButtonOnClick={onCloseChangePlanModal}
      dataHook='change-plan-modal'
    >
      <div className={s.changePlanModalLayout}>
        <ChangePlanModalComparePlans />
        <ChangePlanModalSummary />
        <ChangePlanModalMessage />
      </div>
    </CustomModalLayout>
  );
};
